module.exports = __webpack_public_path__ + "img/not-drinkable.5ee4d11d.svg";